export default "__VITE_ASSET___sUbBTms__"